import initLazyLoad from "../lazy-load/LazyLoad";
import { sendGoogle } from "../Analytics";
import { BREAKPOINTS, IMAGE_LOADING } from "../ApplicationConfig";
import ApplicationState from "../ApplicationState";
import loadIndicator from "../LoadIndicator";
import tabAccordion from "../TabAccordion";
import { setSessionParam } from "../Utils";
import RemotePagination from "../pagination/RemotePagination";
import initDefaultModalFormLoader from "../modal/DefaultModalFormLoader";
import initLinkEmulator from "../LinkEmulator";
import CompareButton from "../CompareButton";

if (typeof IntersectionObserver === 'undefined') {
    require('intersection-observer');
}

/**
 * Новый код прописывать как методы класса. Высокая связность некоторых элементов делает неудобным
 * функциональный стиль
 */
export class CatalogPage
{
    private catalogContainer: Element; 
    private pagination: RemotePagination;

    public constructor()
    {
        this.catalogContainer = document.getElementById('catalog-container');

        if (this.catalogContainer) {
            this.pagination = this.createCatalogPagination();
        }
    }

    public init()
    {
        this.adjustHeight();
        this.initSwitchCatalogView();
        this.initShowMoreButton();
    }

    private createCatalogPagination(): RemotePagination
    {
        let catalogUrl = this.catalogContainer.getAttribute('data-catalog-url');

        let pagination = new RemotePagination(
            Number(this.catalogContainer.getAttribute('data-per-page') || 30),
            Number(this.catalogContainer.getAttribute('data-total') || 0)
        );

        if (catalogUrl) {
            pagination.setCatalogUrl(catalogUrl);
        }

        return pagination;
    }

    private initShowMoreButton()
    {
        if (!this.catalogContainer) {
            return;
        }

        document.querySelectorAll('.js-catalog-show-more-button').forEach(button => {
            button.addEventListener('click', () => {
                loadIndicator(button, false);

                this.pagination.loadNext()
                    .then((rsp: any) => {
                        this.extendProductList(rsp);

                        this.pagination.loadPaginationHtml('/catalog/pagination/').then(rsp => {
                            this.updatePaginationHtml('.js-catalog-pagination', rsp.data);
                        });

                        if (this.pagination.isPageLast()) {
                            button.remove();
                        }

                        loadIndicator(button, true);
                    }).catch(() => loadIndicator(button, true));
            });
        });
    }

    private updatePaginationHtml(selector: string, html: string)
    {
        let parent: Element = null;

        document.querySelectorAll(selector).forEach(node => {
            parent = node.parentElement;
            node.remove();
        });

        parent.insertAdjacentHTML('beforeend', html);
    }

    private createLoadingImage(): HTMLImageElement
    {
        let image = document.createElement('img');
        image.height = 16;
        image.width = 16;
        image.src = IMAGE_LOADING;

        return image;
    }

    /**
     * Переключение вида каталога список/плитка
     */

    private initSwitchCatalogView()
    {
        let catalog = document.querySelectorAll('.catalog__view');

        if (catalog.length > 0) {
            window.addEventListener('resize', () => {
                let view = document.querySelector('.catalog__view').getAttribute('data-view');
                if (view !== 'tiles') {
                    catalog.forEach(item => {
                        if (document.documentElement.clientWidth < BREAKPOINTS.XL) {
                            item.classList.remove('catalog__' + view);
                            item.classList.add('catalog__tiles');
                        } else if (document.documentElement.clientWidth >= BREAKPOINTS.XL) {
                            item.classList.remove('catalog__tiles');
                            item.classList.add('catalog__' + view);
                        }

                        item.querySelectorAll('.product').forEach(product => {
                            if (document.documentElement.clientWidth < BREAKPOINTS.XL) {
                                product.classList.remove('product__' + view);
                                product.classList.add('product__tiles');
                            } else if (document.documentElement.clientWidth >= BREAKPOINTS.XL) {
                                product.classList.remove('product__tiles');
                                product.classList.add('product__' + view);
                            }

                            product.querySelectorAll('.baloon').forEach(baloon => {
                                if (document.documentElement.clientWidth < BREAKPOINTS.XL) {
                                    baloon.classList.remove('baloon__catalog-' + view);
                                    baloon.classList.add('baloon__catalog-tiles');
                                } else if (document.documentElement.clientWidth >= BREAKPOINTS.XL) {
                                    baloon.classList.remove('baloon__catalog-tiles');
                                    baloon.classList.add('baloon__catalog-' + view);
                                }
                            });
                        });
                    });
                }
            });
        }

        document.querySelectorAll('.js-switch-catalog-view').forEach(node => {
            node.addEventListener('switcher-change', evt => {
                let e = evt as CustomEvent;

                catalog.forEach(item => {

                    let currentView = item.getAttribute('data-view');
                    item.classList.remove('catalog__' + currentView);
                    item.classList.add('catalog__' + e.detail);
                    item.setAttribute('data-view', e.detail);

                    item.querySelectorAll('.product').forEach(product => {
                        product.classList.remove('product__' + currentView);
                        product.classList.add('product__' + e.detail);

                        product.querySelectorAll('.baloon').forEach(baloon => {
                            baloon.classList.remove('baloon__catalog-' + currentView);
                            baloon.classList.add('baloon__catalog-' + e.detail);
                        });                    
                    });
                });

                setSessionParam('catalog_view', e.detail);

            });
        });
    }
    
    private extendProductList(rsp)
    {
        const HTML_INIT_CLASS = 'js-need-initialization';
        // let jsonRegExp = new RegExp(/<variationsjson>(.+)<\/variationsjson>/i);
        // let variationsJson = rsp.data.match(jsonRegExp);
        let data = rsp.data.replaceAll('catalog__product', 'catalog__product ' + HTML_INIT_CLASS);

        //data = data.replace(jsonRegExp, '');

        try {
            // let newVariations = JSON.parse(variationsJson[1]);

            this.catalogContainer.insertAdjacentHTML('beforeend', data);
            // this.variationsController.appendVariations(newVariations);
            
            // this.initIconsHover('.' + HTML_INIT_CLASS + ' .js-product-icons');
            initLazyLoad('.ll');
            
            // this.instantiateMiniSliders('.' + HTML_INIT_CLASS + ' .js-catalog-limited-space-slider');
            // this.startMiniSlidersObserving();
            
            // sendAnalyticsByClick('.' + HTML_INIT_CLASS + ' .js-metrics-by-click');
            initDefaultModalFormLoader('.' + HTML_INIT_CLASS + ' .js-load-modal');
            initLinkEmulator('.' + HTML_INIT_CLASS + ' .js-catalog-button-buy');

            new CompareButton('.' + HTML_INIT_CLASS + ' .js-action-compare').init();

        } catch ($e) {
            console.error($e);
        }

        this.catalogContainer.querySelectorAll('.' + HTML_INIT_CLASS).forEach(item => {
            item.classList.remove(HTML_INIT_CLASS);
        });
    }

    /**
    * Выравниваем высоту блоков в карточках и менячем высоту самих карточек
    * TODO: реализовать изменение высоты карточки в зависимости от ее содержимого (актуально для ибп, там всего 2 типа характеристик)
    */
    private adjustHeight()
    {
        let catalog = document.getElementsByClassName('catalog__product')[0] as HTMLElement;
        if (catalog) {
            let maxHeight        = 0;
            let heightDifference = 0;
            let productWrapper   = document.getElementsByClassName('product__wrapper')[0] as HTMLElement;
            let title            = document.getElementsByClassName('product__title')[0] as HTMLElement;
            let heightAdjuster   = document.getElementsByClassName('product__height-adjuster')[0] as HTMLElement;
            if (heightAdjuster) {
                heightDifference = heightAdjuster.offsetHeight;
            }
            let sticker          = document.getElementsByClassName('product__sticker')[0] as HTMLElement;
            let stickerEmpty     = document.getElementsByClassName('product__sticker_empty')[0] as HTMLElement;
            let specifications   = document.getElementsByClassName('product__specifications-wrapper')[0] as HTMLElement;
            let productFooter    = document.getElementsByClassName('product__footer')[0] as HTMLElement;
            //let productPadding   = parseFloat(window.getComputedStyle(productWrapper , null).getPropertyValue('padding-bottom'));

            document.querySelectorAll('.product__title').forEach(node => {
                let title = node as HTMLElement;

                if (title.offsetHeight > maxHeight) {
                    maxHeight = title.offsetHeight;
                }
            });

            heightDifference = heightDifference - (maxHeight - title.offsetHeight);

            document.querySelectorAll('.product__title').forEach(node => {
                let title = node as HTMLElement;
                title.style.height = maxHeight + 'px'; 
            });

            maxHeight = 0;

            document.querySelectorAll('.product__specifications-wrapper').forEach(node => {
                let specifications = node as HTMLElement;

                if (specifications.offsetHeight > maxHeight) {
                    maxHeight = specifications.offsetHeight;
                }
            });

            document.querySelectorAll('.product__specifications-wrapper').forEach(node => {
                let specifications = node as HTMLElement;
                specifications.style.height = maxHeight + 'px'; 
            });

            if (sticker) {
                document.querySelectorAll('.product__sticker_empty').forEach(node => {
                    let item = node as HTMLElement;
                    item.style.height = sticker.offsetHeight + 'px';
                });
            } else {
                heightDifference = (heightDifference + stickerEmpty.offsetHeight);   
                document.querySelectorAll('.product__sticker_empty').forEach(node => {
                    let item = node as HTMLElement;
                    item.style.height = 0 + 'px';
                });
            }

            document.querySelectorAll('.product__height-adjuster').forEach(node => {
                let item = node as HTMLElement;
                item.style.height = heightDifference + 'px';
            });

            // после выравнивания всех блоков получаем высоту блока .product

            //let product          = document.getElementsByClassName('product')[0] as HTMLElement;

            //let newProductHeight = product.offsetHeight - productPadding - productFooter.offsetHeight;

            // document.querySelectorAll('.catalog__product').forEach(node => {
            //     let catalogProduct = node as HTMLElement;
            //     catalogProduct.style.height = newProductHeight + 'px'; 
            // });

            // document.querySelectorAll('.product').forEach(node => {
            //     let product = node as HTMLElement;
            //     product.style.height = newProductHeight + 'px'; 
            // });
        }
    }
}

export default function initCatalog()
{
    // отображать по / сортировать по
    document.querySelectorAll('.js-catalog-control-select').forEach(item => {
        item.addEventListener('valueselected', (evt) => {
            let e = evt as CustomEvent;
            window.location.href = e.detail.value;
        });
    });

    //выделение ссылки в перелинковке
    document.querySelectorAll('.relink_top a.link').forEach(item => {
        if ( window.location.href.indexOf(item.getAttribute('href')) > -1 ) {
            item.classList.add('f-bold');
        }
    });

    navigateByFilterTags();
    new CatalogPage().init();
}

/**
 * Навигация по тегам под фильтром
 */
function navigateByFilterTags()
{
    let tags = document.getElementsByClassName('js-filter-tags').item(0);
    
    if (!tags) {
        return;
    }

    tags.addEventListener('tags-item-selected', evt => {
        let e = evt as CustomEvent;

        window.location.href = '/catalog/search/?' + e.detail.key;
    });
}
